import { autoLoginWithApiKey, isAuthenticated } from './authService';

const API_BASE_URL = 'https://apicabaza.creago.be/rest/cabaza/peoples';

// Auto-login on first use (for demo purposes)
if (!isAuthenticated()) {
    autoLoginWithApiKey();
}

// Get statistics for dashboard
export async function getStats(period = 'week') {
    try {
        const response = await fetch(`${API_BASE_URL}/stats?period=${period}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();
        console.log('Stats response:', data);
        return data;
    } catch (error) {
        console.error('Error fetching stats:', error);
        throw error;
    }
}

// Get all people
export async function getAllPeople(params = {}) {
    try {
        const queryParams = new URLSearchParams(params);
        console.log('Fetching people with params:', params);
        const response = await fetch(`${API_BASE_URL}?${queryParams}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();
        console.log('People response:', data);
        return data;
    } catch (error) {
        console.error('Error fetching people:', error);
        throw error;
    }
}

// Get people by UUID
export async function getPeopleByUuid(uuid) {
    try {
        const response = await fetch(`${API_BASE_URL}/${uuid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`Error fetching people ${uuid}:`, error);
        throw error;
    }
}

// Legacy aliases
export const getPersonByUuid = getPeopleByUuid;
export const getPersonById = getPeopleByUuid;

// Create people
export async function createPeople(peopleData) {
    try {
        const response = await fetch(API_BASE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(peopleData)
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating people:', error);
        throw error;
    }
}

// Legacy alias
export const createPerson = createPeople;

// Update people
export async function updatePeople(uuid, peopleData) {
    try {
        console.log('=== adminApiService.updatePeople ===');
        console.log('UUID:', uuid);
        console.log('People data to send:', peopleData);
        console.log('Role:', peopleData.role);
        console.log('JSON body:', JSON.stringify(peopleData));

        const response = await fetch(`${API_BASE_URL}/${uuid}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(peopleData)
        });

        const data = await response.json();
        console.log('Response from API:', data);
        return data;
    } catch (error) {
        console.error(`Error updating people ${uuid}:`, error);
        throw error;
    }
}

// Legacy alias
export const updatePerson = updatePeople;

// Delete people
/**
 * En-têtes d'un appel authentifié.
 *
 * Le JWT de l'utilisateur connecté est écrit sous `authToken` par
 * `AuthContext.saveUserToStorage` ; `sessionStorage` prend le relais quand
 * l'utilisateur n'a pas coché « rester connecté ».
 *
 * Sans lui, le serveur ne sait pas QUI appelle — et une suppression de compte
 * ne peut pas se contenter de savoir que l'appel vient d'un outil autorisé.
 */
function enTetesAuth() {
    let token = null;
    try {
        token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    } catch {
        token = null;
    }

    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
}

export async function deletePeople(uuid) {
    try {
        // Le serveur vérifie désormais que l'UUID visé est celui du porteur du
        // JWT : on ne supprime que son propre compte. Sans cet en-tête, l'appel
        // repart en 401.
        const response = await fetch(`${API_BASE_URL}/${uuid}`, {
            method: 'DELETE',
            headers: enTetesAuth()
        });

        const data = await response.json();

        // UN REFUS DOIT LEVER, avec son statut. Rendre le corps JSON d'une
        // reponse 402 laissait l'appelant croire au succes : c'est
        // precisement le cas ou Mollie a refuse la resiliation et ou le
        // compte est INTACT — l'utilisateur doit le savoir.
        if (!response.ok) {
            const erreur = new Error(data?.message ?? data?.MESSAGE ?? 'Suppression refusee');
            erreur.status = response.status;
            throw erreur;
        }

        return data;
    } catch (error) {
        console.error(`Error deleting people ${uuid}:`, error);
        throw error;
    }
}

/**
 * Ce qu'une suppression de compte engagera, sans rien supprimer.
 *
 * Sert a la modale de confirmation : annoncer que des factures seront
 * conservees et qu'un abonnement sera resilie suppose de le savoir.
 *
 * Ne leve pas : une previsualisation indisponible ne doit pas empecher
 * d'ouvrir la confirmation. La modale annoncera alors seulement ce qui
 * part, ce qui reste vrai dans tous les cas.
 */
export async function previsualiserEffacement(uuid) {
    try {
        const response = await fetch(`${API_BASE_URL}/${uuid}/previsualiser-effacement`, {
            method: 'GET',
            headers: enTetesAuth()
        });

        if (!response.ok) return {};

        const data = await response.json();
        const brut = data?.data ?? data?.DATA ?? {};

        // Les cles arrivent en minuscules depuis ColdFusion.
        return {
            aUnAbonnement: brut.aUnAbonnement ?? brut.aunabonnement ?? false,
            aDesFactures: brut.aDesFactures ?? brut.adesfactures ?? false,
            nbFichiers: brut.nbFichiers ?? brut.nbfichiers ?? 0
        };
    } catch (error) {
        console.warn(`Previsualisation indisponible pour ${uuid}:`, error);
        return {};
    }
}

// Legacy alias
export const deletePerson = deletePeople;
